import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UserSubscription} from "../../../../../../user/user-subscription";
import {filter} from "rxjs";
import {first, switchMap} from "rxjs/operators";
import * as fromStore from "../../../../../../store";
import {Store} from "@ngrx/store";
import {BuilderStepsEnum} from "../../../../../../builder-v2/builder-tour.enum";
import {AuthService} from "../../../../../../auth/auth.service";
import {ActivatedRoute} from "@angular/router";
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {BuilderSectionsInteractionService} from "../../../../../../builder-v2/builder-sections-interaction.service";

@Component({
    selector: 'db-create-ai-assistant-choose-website-type',
    templateUrl: './create-ai-assistant-choose-website-type.component.html',
    styleUrls: ['./create-ai-assistant-choose-website-type.component.scss'],
    standalone: false
})
export class CreateAiAssistantChooseWebsiteTypeComponent implements OnInit, OnChanges, OnDestroy {
  protected readonly builderStep = BuilderStepsEnum;
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<string>();
  @Output() close ? = new EventEmitter<void>();
  @Input() fromStartAIPage?: boolean = false;
  @Input() isFromGenerate?: boolean = false;
  @Input() showAsDialog?: boolean = false;
  @Input() forRecreateFirstTime?: boolean = false;
  @Input() signUpWithHubspot?: boolean = false;
  @Input() fromDomains?: any;
  @Input() domainName?: string;
  @Input() loading: BehaviorSubject<boolean>;

  public websiteType: string = '';
  public blockedOption: boolean = false;
  public isMobile: boolean = false;
  public emailCampaign: boolean = false;
  public userSubscription: UserSubscription;
  lottieConfig: any;

  constructor(
    private _route: ActivatedRoute,
    private _authService: AuthService,
    private _store: Store<fromStore.DbStoreState>,
    private _builderSectionsInteractionsService: BuilderSectionsInteractionService
  ) {
  }

  ngOnInit() {
    this.lottieConfig = {
      path: 'assets/images/lotties/new-flow.json',
      renderer: 'svg',
      autoplay: true,
      loop: true
    };
    const queryParams: any = (<any>this._route.queryParams).value;
    this.emailCampaign = !!(queryParams.emailCampaign || new URL(window.location.href).searchParams.get("emailCampaign")) && !window.location.href.includes('setup-onboarding') && !this.showAsDialog;
    this.isMobile = window.innerWidth <= 991;
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        if (userSubscription) {
          this.userSubscription = userSubscription;
          this.blockedOption = userSubscription && userSubscription.plan && !userSubscription.plan.woocommerceService;
        }
      });

    this._builderSectionsInteractionsService.setBackAction(() => {
      this.backToPreviousStep()
    });

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes && changes['showAsDialog'] && changes['showAsDialog'].currentValue) {
      this.websiteType = '';
      this.loading.next(false);
    }
  }

  public backToPreviousStep(): void {
    this.back.emit();
  }

  public onWebsiteTypeChange(type: string): void {
    this.websiteType = type;
  }

  public proceedToNextQuestion(): void {
    this.loading.next(true);
    this.next.emit(this.websiteType);
  }


  public signOut(): void {
    if (this._authService.canLogout()) {
      this._authService.logout(null);
    }
  }

  ngOnDestroy() {
    this.loading.next(false);
  }

}
